// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__27KKB","productName":"Table_productName___yepL"};